import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import AnchorButton from 'components/common/AnchorButton';

import { padNumber } from 'utils/helpers';

export type PrizeType = {
    id: number;
    keyDisplay: string;
    winnerDisplay: string;
    tierDisplay: string;
    winningNumbers: number[];
};

function RafflePrizes({ prizes, numberPadding }: Readonly<{ prizes: PrizeType[]; numberPadding: number }>) {
    const [expandedIds, setExpandedIds] = useState<number[]>([]);
    const { t } = useTranslation();

    function showWinningTicket(id: number) {
        const index = expandedIds.indexOf(id);
        setExpandedIds(index > -1 ? expandedIds.filter((n, i) => i !== index) : [...expandedIds, id]);
    }

    const getPrizesRow = (prize: PrizeType) => (
        <React.Fragment key={prize.id}>
            <tr>
                <td>{prize.keyDisplay}</td>
                <td>{prize.winnerDisplay}</td>
                <td>{prize.tierDisplay}</td>
                <td>
                    <AnchorButton
                        onClick={() => showWinningTicket(prize.id)}
                        className="raffle-winning-tickets-collapse cursor-pointer"
                    >
                        {t('prizes.showTickets')}
                    </AnchorButton>
                </td>
            </tr>
            {expandedIds.includes(prize.id) && (
                <tr className="fade-in">
                    <td colSpan={4} className="w-50">
                        {prize.winningNumbers.map((number) => (
                            <div key={number} className="raffle-winning-number">
                                {padNumber(number, numberPadding)}
                            </div>
                        ))}
                    </td>
                </tr>
            )}
        </React.Fragment>
    );

    return (
        <div className="results-main results-main-raffle">
            <div className="table-container-raffle raffle-results-table">
                <table>
                    <thead>
                        <tr>
                            <th>{t('prizes.tier')}</th>
                            <th>{t('prizes.winners')}</th>
                            <th>{t('prizes.prize')}</th>
                            <th>{t('prizes.winnersTickets')}</th>
                        </tr>
                    </thead>
                    <tbody>{prizes.map((prize) => getPrizesRow(prize))}</tbody>
                </table>
            </div>
        </div>
    );
}

export default RafflePrizes;
